export default "__VITE_ASSET__466c97f0__"